module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/assessment_achievements/4_dc4a3a8a29b8c4615c12e044c1f2004f.jpg";